<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New FAQ</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                  label="Kategori"
                  :options="newOptionsCategory"
                  required
                  horizontal
                  v-model="faqData.category"
                  @change="handleCategory"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                  label="Topic"
                  :options="getOptionsTopic"
                  required
                  horizontal
                  v-model="faqData.topic"
                  @change="handleTopic"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                  label="Sub Topic"
                  class="mb-0"
                  required
                  horizontal
                  placeholder="Sub Topic"
                  v-model.trim="faqData.sub_topic"
                  @change="handleSubTopic"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                  label="Pertanyaan"
                  class="mb-0"
                  horizontal
                  placeholder="Pertanyaan"
                  v-model.trim="faqData.question"
                  @change="handleQuestion"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CTextarea
                id="meta_description"
                label="Meta Description"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Description"
                v-model="faqData.meta_info_description"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CTextarea
                id="meta_description"
                label="Meta Keyword"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Keyword"
                v-model="faqData.meta_info_keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                  type="number"
                  min="0"
                  max="1000"
                  label="Priority"
                  class="mb-0"
                  horizontal
                  placeholder="Priority to show on Website"
                  v-model="faqData.priority"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <a>Jawaban</a>
              <editor
                id="editor"
                :api-key="key"
                :init="initOption"
                v-model="content"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="updateFaq"
              >Submit
              </CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import FAQUseCase from "./app/usecase";
import Editor from "@tinymce/tinymce-vue";
import jwt from "jsonwebtoken";
import FAQEnum from "./app/constants/options";
import initTinymce from "@/app/constants/initTinymce";

export default {
  name: "FaqEdit",
  components: { editor: Editor },
  computed: {
    getOptionsTopic() {
      if (this.faqData.category === "BANTUAN") {
        return this.newOptionsHelp
      }
      return this.newOptionsApps
    },
  },
  data() {
    return {
      faqData: {},
      tempData: {},
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      newOptionsHelp: FAQEnum.OPTION_TOPIC_HELP,
      newOptionsApps: FAQEnum.OPTION_TOPIC_APPS,
      newOptionsCategory: FAQEnum.OPTION_CATEGORY,
      content: "",
      initOption: initTinymce.init,
      key: initTinymce.key,
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  methods: {
    async getDataByID() {
      const faqID = this.$route.params.id;
      try {
        const resp = await FAQUseCase.getOne(+faqID)
        // // JSON responses are automatically parsed.
        this.tempData = resp.data
        delete resp.data["histories"]
        this.faqData = resp.data
        this.content = resp.data.answer
      } catch (err) {
        await this.$router.push({path: "/management/faq"});
      }
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "NPOS" ||
          data.account_group === "QC" ||
          data.account_group === "COMMUNITY" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({path: `/`});
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/management/faq"});
    },
    handleCategory(event) {
      this.faqData.category = event.target.value;
    },
    handleTopic(event) {
      this.faqData.topic = event.target.value;
    },
    handleSubTopic(event) {
      this.faqData.sub_topic = event;
    },
    handleQuestion(event) {
      this.faqData.question = event;
    },
    async updateFaq() {
      const faqID = this.$route.params.id;
      this.faqData = FAQUseCase.setTopicOnChangeCategory(this.faqData, this.getOptionsTopic)
      this.faqData.answer = this.content;
      try {
        const resp = await FAQUseCase.updateOne(+faqID, this.faqData)
        if (resp.err) {
          await this.$swal.fire({
            icon: "warning",
            title: "Oops",
            text: resp.err,
          })
        } else {
          let msg = "FAQ Updated"
          if (resp.message && resp.message !== "") {
            msg += ", " + resp.message
          }
          await this.$swal.fire({
            icon: "success",
            title: msg,
            showConfirmButton: false,
            timer: 2000,
          })
          await this.$router.push({path: `/management/faq`});
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.err,
        });
      }
    },
  },
};
</script>

<style scoped>
@import "./Faq.css";
</style>
